/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { requestEmailOTPRequestSchema } from "./requestEmailOTPRequestSchema.ts";
import { unauthorizedSchema } from "./unauthorizedSchema.ts";

export const userUpdateEmailRequestOtpCreateStatus200Schema = z.any();

export const userUpdateEmailRequestOtpCreateStatus400Schema = errorResponseSchema;

export const userUpdateEmailRequestOtpCreateStatus401Schema = unauthorizedSchema.describe("Сериализатор 401 ошибки - для документации.");

export const userUpdateEmailRequestOtpCreateResponseSchema = z.union([
	userUpdateEmailRequestOtpCreateStatus200Schema,
	userUpdateEmailRequestOtpCreateStatus400Schema,
	userUpdateEmailRequestOtpCreateStatus401Schema,
]);

export const userUpdateEmailRequestOtpCreateDataSchemaJson = requestEmailOTPRequestSchema.describe("Сериализатор запроса ОТП-кода для обновления email.");

export const userUpdateEmailRequestOtpCreateDataSchemaXml = requestEmailOTPRequestSchema.describe("Сериализатор запроса ОТП-кода для обновления email.");

export const userUpdateEmailRequestOtpCreateDataSchema = z.union([userUpdateEmailRequestOtpCreateDataSchemaJson, userUpdateEmailRequestOtpCreateDataSchemaXml]);
